import { computed, inject, Injectable, signal, Signal } from '@angular/core';
import { AppDocumentType } from '../../models/documents/document-type.enum';
import { JourneyType } from '../../models/documents/journey-type.enum';
import { COMMON_CONFIG } from '../../tokens/common-config.token';

@Injectable({ providedIn: 'root' })
export class DocumentPathService {
  private readonly config = inject(COMMON_CONFIG);

  private readonly assetsPath = this.config.assetsPath;
  private readonly _journeyType = signal<JourneyType>(
    JourneyType.ApplianceCare,
  );

  readonly journeyType: Signal<JourneyType> = this._journeyType.asReadonly();
  readonly guaranteeTermsAndConditionsUrl = this.getDocumentPathFor(
    AppDocumentType.GuaranteeTermsAndConditions,
  );
  readonly ipidUrl = this.getDocumentPathFor(AppDocumentType.Ipid);
  readonly termsAndConditionsUrl = this.getDocumentPathFor(
    AppDocumentType.TermsAndConditions,
  );

  setJourneyType(journeyType: JourneyType): void {
    this._journeyType.set(journeyType);
  }

  private getDocumentPathFor(appDocumentType: AppDocumentType): Signal<string> {
    return computed(
      () =>
        `${this.assetsPath}/documents/${appDocumentType}-${this._journeyType()}.pdf`,
    );
  }
}
